import { createApp } from 'vue'
import mitt from 'mitt';

try {
    window._ = require('lodash');
} catch (e) {

}

const emitter = mitt();

window.emitter = emitter;

const components = [];

// noinspection JSUnresolvedFunction
const requireComponent = require.context('./components/', true, /\.vue$/i);

requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);

    const componentName = _.upperFirst(
        _.camelCase(
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    );

    components.push({name: componentName, config: componentConfig.default || componentConfig});
})

const app = createApp({});

app.config.globalProperties.emitter = emitter;

components.forEach(component => app.component(component.name, component.config));

app.mount('#calculator_plweb');

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-Bitrix-Csrf-Token'] = BX.bitrix_sessid();
